import Popup from "@Views/comp/Popup";
import { elePrint } from "@Views/utils/FileUtils";
import { forwardRef, useImperativeHandle, useRef } from "react";
import { useTranslation } from "react-i18next";

const GuideLineForUsePopup = forwardRef(({},ref)=>{

    const { t } = useTranslation();
    const msg:any = t("comMsg", { returnObjects: true });

    const printRef:any = useRef();
    const guideLineForUsePopupRef:any = useRef(); 
    useImperativeHandle(ref,()=>({
        isOpen(val:boolean){
            guideLineForUsePopupRef['current'].isOpen(val);
        }
    }))

    return(
        <Popup title={msg['guideLineForUsePopupTitle']} className="modal-lg" ref={guideLineForUsePopupRef}>
            <div className="modal-body set-height">
                <div className="modal-comp">
                    <div className="txt-con">
                        <div className="con-desc" tabIndex={0} ref={printRef}>
                            <p className="txt-blue"  dangerouslySetInnerHTML={{__html:msg['guideLinePopupHedaerTitle']}}></p>
                            <strong className="tri-bullet">{msg['guideLinePopupSubTitle01']}</strong><br/>
                            <p dangerouslySetInnerHTML={{__html:msg['guideLinePopupSubTitle01Desc']}}></p>
                            <strong className="tri-bullet">{msg['guideLinePopupSubTitle02']}</strong><br/>
                            <p dangerouslySetInnerHTML={{__html:msg['guideLinePopupSubTitle02Desc']}}></p>
                            <strong className="tri-bullet">{msg['guideLinePopupSubTitle03']}</strong><br/>
                            <p dangerouslySetInnerHTML={{__html:msg['guideLinePopupSubTitle03Desc']}}></p>
                            <p className="si-info"><strong>{msg['guideLinePopupFooterTitle']}</strong></p>
                            <p dangerouslySetInnerHTML={{__html:msg['guideLinePopupFooterDesc']}}></p>
                        </div>
                        <div className="btn-wrap">
                            <button type="button" className="btn btn-popup positive" onClick={() => elePrint(printRef['current'])}>{msg['print']}</button>
                            <button type="button" className="btn btn-popup positive" onClick={() => guideLineForUsePopupRef['current'].isOpen(false)}>{msg['close']}</button>
                        </div>
                    </div>
                </div>
            </div>
        </Popup>
    )
})

export default GuideLineForUsePopup;